import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useId } from 'react'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface BrandMarkProps {
    className?: string
}

interface BrandLogoProps {
    className?: string
    onNavigate?: () => void
}

export const BrandMark: FC<BrandMarkProps> = ({ className }): ReactNode => {
    const gradientId = `kz-gold-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`
    const gold = `url(#${gradientId})`

    return (
        <svg
            viewBox='0 0 64 64'
            aria-hidden='true'
            focusable='false'
            className={cn('shrink-0', className)}
        >
            <defs>
                <linearGradient id={gradientId} x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='0' stopColor='#ecd594' />
                    <stop offset='1' stopColor='#b8903a' />
                </linearGradient>
            </defs>

            <circle cx='32' cy='32' r='31' fill='#0f2a1e' />
            <circle cx='32' cy='32' r='28.4' fill='none' stroke={gold} strokeWidth='1.8' />
            <path d='M12.5 42 L23 26.5 L27.6 32.1 L34.2 17.5 L41.8 29.2 L44.8 26.1 L51.5 42 Z' fill={gold} />
            <path d='M34.2 17.5 L37.3 22.3 L35.6 21.7 L34.1 23.3 L32.8 21.9 L31.9 22.6 Z' fill='#f8f3e8' opacity='0.85' />
            <path
                d='M31 42 C26.5 45 38.5 46.6 33.6 50.4 C31 52.4 33 54 31.6 55.5'
                fill='none'
                stroke='#f8f3e8'
                strokeWidth='2.2'
                strokeLinecap='round'
            />
            <path d='M14.5 50.5 C14.5 42.9 20.5 38.3 28.3 39.1 C26.6 46.5 21.4 50.5 14.5 50.5 Z' fill='#3e7d57' />
            <path d='M14.5 50.5 C18.5 46.9 22.5 43.9 28.3 39.1' fill='none' stroke={gold} strokeWidth='1' />
            <path d='M49.5 50.5 C49.5 44.3 44.9 40.5 38.9 40.9 C40.1 46.9 44.3 50.5 49.5 50.5 Z' fill='#2c6646' />
        </svg>
    )
}

export const BrandLogo: FC<BrandLogoProps> = ({ className, onNavigate }): ReactNode => {
    return (
        <Link
            href='/'
            onClick={onNavigate}
            aria-label={`${siteConfig.name}، صفحه اصلی`}
            className={cn('group inline-flex items-center gap-3 rounded-full', className)}
        >
            <BrandMark className='size-11 transition-transform duration-500 group-hover:rotate-[8deg]' />

            <span className='flex flex-col'>
                <span className='font-heading text-[1.65rem] font-bold leading-tight text-cream'>
                    {siteConfig.name}
                </span>

                <span className='text-[0.62rem] font-medium uppercase leading-tight tracking-[0.3em] text-gold'>
                    {siteConfig.nameLatin}
                </span>
            </span>
        </Link>
    )
}
